$(function(){
  $('.calendar-box__button').on("click",function(){

    var $item = $(this),
    direction = $item.data('direction'),
    element = $('[data-role="calendar-month"]'),
    buttons = $('.calendar-box__button');
    if(direction == "prev"){
      var month = element.data("month-prev");
      var year = element.data("year-prev");
    }else if(direction == "next"){
      var month = element.data("month-next");
      var year = element.data("year-next");
    }

    var dataHolder = $('[data-role="calendar-data"]');
    var method = dataHolder.data('method');
    var itemsHolder = $('[data-role="calendar-items-holder"]');

    buttons.addClass('calendar-box__button--loading');
    itemsHolder.addClass('calendar-box__results--loading');
    element.addClass('calendar-box__title--loading');

    $.ajax({
      method : 'get',
      url : data.base_url + method,
      dataType : 'json',
      data : {
        month : month,
        year : year
      }
    }).done(function(data){
      var json = JSON.parse(data);

      element.data('month-next',json.next_month);
      element.data('year-next',json.next_year);
      element.attr('data-next',json.next_label);

      element.data('month-prev',json.prev_month);
      element.data('year-prev',json.prev_year);
      element.attr('data-prev',json.prev_label);

      itemsHolder.html(json.html);
      element.html(json.title);

      buttons.removeClass('calendar-box__button--loading');
      itemsHolder.removeClass('calendar-box__results--loading');
      element.removeClass('calendar-box__title--loading');
    });
    return false;
  });
})
